module.exports = __webpack_public_path__ + "static/detroit-02bc5a278a98080b993900f722479918.png";